import { render, staticRenderFns } from "./DisclaimersAll.vue?vue&type=template&id=36d72709&"
import script from "./DisclaimersAll.vue?vue&type=script&lang=ts&"
export * from "./DisclaimersAll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports